import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Col, Row, Skeleton } from 'antd'
import { Formik } from 'formik'
import moment from 'moment'
import * as Yup from 'yup'

import { BenefitStartDateValues } from 'core/application/adminDashboard/benefitDetails/design/common/models'
import benefitStartDateApi, {
  availableBenefitStartDatesApi,
} from 'core/application/adminDashboard/benefitDetails/design/groupHra/groupHraBenefitDesignStartDate'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'
import notification from 'common/components/feedback/Notification'

import { commandRequest } from 'common/RequestUtils'

import { BaseComponentProps } from '../common/models'

import '../common/DesignStyles.less'

const formValidator = (translate: any) =>
  Yup.object({
    benefitStartDate: Yup.date().required(translate('general.required')),
  })

const GroupHraBenefitStartDate: React.FC<BaseComponentProps<BenefitStartDateValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const [startDateOptions, setStartDateOptions] = useState<string[]>([])
  const { t: translate } = useTranslation()
  const { planPeriod } = useParams() as any

  useEffect(() => {
    availableBenefitStartDatesApi(planPeriod).then((response) => {
      setStartDateOptions(response)
      props.setIsFormValid(formValidator(translate).isValidSync(props.state))
    })
  }, [])

  const onSubmit = async (values: BenefitStartDateValues) => {
    let benefitStartDateValues: BenefitStartDateValues = {
      benefitStartDate: values.benefitStartDate,
      planPeriodId: planPeriod as string,
    }

    const res = await commandRequest(() => benefitStartDateApi(benefitStartDateValues))
    if (!res.errors) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
      notification.open({
        message: res.errors[0],
        type: 'error',
      })
    }
  }

  const getRadioElement = (option: string) => {
    return (
      <Radio.Button size="large" value={option}>
        {moment.parseZone(option).format('MMMM YYYY')}
      </Radio.Button>
    )
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={props.state}
      onSubmit={onSubmit}
      validate={(values) => {
        props.hasDirtyData(true)
        props.setIsFormValid(formValidator(translate).isValidSync(values))
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form onSubmit={handleSubmit} autoComplete="off" className={'t-benefit-design-start-date'}>
            <Row>
              <Col
                sm={{ span: 24, offset: 0 }}
                md={{ span: 20, offset: 2 }}
                lg={{ span: 17, offset: 3 }}
                className="benefit_design_page_header"
              >
                <h5 className={'t-benefit-design-start-date-header'}>
                  {translate('admin-dashboard.benefit-details.benefit-start-date.header')}
                </h5>
                <h6 className={'t-benefit-design-start-date-subheader'}>
                  {translate('admin-dashboard.benefit-details.benefit-start-date.subheader')}
                </h6>
              </Col>
            </Row>
            <Row justify={'center'} className="form__row">
              <Col sm={24} md={20} lg={18}>
                <Skeleton loading={startDateOptions.length === 0} active>
                  <Radio.Group
                    className={'w-100 t-benefit-design-start-date-radiou-group'}
                    name="benefitStartDate"
                    defaultValue={props.state.benefitStartDate}
                  >
                    <Row justify={'center'} className={'mb-8'} gutter={10}>
                      {startDateOptions?.slice(0, 3).map((option: string, index: number) => {
                        return (
                          <Col xs={8} key={index}>
                            {getRadioElement(option)}
                          </Col>
                        )
                      })}
                    </Row>
                    <Row gutter={10}>
                      {startDateOptions?.slice(3, 6).map((option: string, index: number) => {
                        return (
                          <Col xs={8} key={index}>
                            {getRadioElement(option)}
                          </Col>
                        )
                      })}
                    </Row>
                  </Radio.Group>
                </Skeleton>
              </Col>
            </Row>
          </form>
        )
      }}
    </Formik>
  )
}

export default GroupHraBenefitStartDate
